import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
export const WorkspaceLoginSchema = z.object({
    workspaceId: z.string(),
});
export class WorkspaceLoginDto extends createZodDto(WorkspaceLoginSchema) {
}
